// extracted by mini-css-extract-plugin
export default {"selectWalletContainer":"WalletModal_selectWalletContainer__zqzmV","walletTile":"WalletModal_walletTile__jE1En"};